import { useAtom } from '@reatom/npm-react'
import { memo, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { FlashTextContentDistinct } from '@root/features/flash/flash-text-content-distinct'
import { NumericFormat } from '@root/shared/core/format'
import { ProfileIcon } from '@root/shared/ui-kit'

import { PairStatsPanelTopRowItem } from './pair-stats-panel-top-row-item'

import type { PairModel } from '@root/entities/pair'

type Props = {
  pair: PairModel
}

export const PairStatsPanelTop10Holders: React.FC<Props> = memo(({ pair }) => {
  const { t } = useTranslation()
  const [audit] = useAtom(pair.audit)
  const top10holding = audit.checks.top10HoldersPercentage.percent

  const formatted = useMemo(
    () => NumericFormat.formatPreset(top10holding, 'percents'),
    [top10holding],
  )

  return (
    <PairStatsPanelTopRowItem
      title={t('trading.audit.top_10_holders.short')}
      intent={audit.checks.top10HoldersPercentage.status}
      icon={ProfileIcon}
      tooltip={t('trading.audit.top_10_holders_tooltip', {
        percentage: NumericFormat.formatPreset(top10holding, 'percents'),
      })}
      value={<FlashTextContentDistinct>{formatted}%</FlashTextContentDistinct>}
    />
  )
})
